import { useEffect } from 'react'
import { useAuth } from './AuthProvider';

function SignoutOidc() {
    let auth = useAuth();

    useEffect(() => {
        async function signoutAsync() {
            await auth?.signoutRedirectCallback();
            auth?.signinRedirect();
        }
        signoutAsync()
    }, [])

    return (
        <div>
            Redirecting...
        </div>
    )
}

export default SignoutOidc